/**
 * AJAX Filter fuer Shopify Search & Discovery App
 * Ersetzt Page-Reload beim Filter-Klick durch dynamisches DOM-Update
 * via Shopify Section Rendering API
 */
(function () {
  'use strict';

  function getSectionId() {
    const el = document.querySelector('[id^="shopify-section-"][id$="__main"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function setLoading(isLoading) {
    const grid = document.querySelector('.productgrid--outer');
    if (!grid) return;
    if (isLoading) {
      grid.style.opacity = '0.5';
      grid.style.pointerEvents = 'none';
      grid.style.transition = 'opacity 0.2s';
    } else {
      grid.style.opacity = '';
      grid.style.pointerEvents = '';
    }
  }

  function replaceContent(selector, newDoc) {
    const newEl = newDoc.querySelector(selector);
    const currentEl = document.querySelector(selector);
    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
    }
  }

  async function fetchFilteredSection(url) {
    const sectionId = getSectionId();
    if (!sectionId) {
      console.error('[AJAX Filter] Section-ID nicht gefunden');
      return null;
    }
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('sections', sectionId);
    const response = await fetch(fetchUrl.toString());
    if (!response.ok) throw new Error('HTTP ' + response.status);
    const json = await response.json();
    const html = json[sectionId];
    if (!html) throw new Error('Section nicht in der Antwort gefunden');
    const parser = new DOMParser();
    return parser.parseFromString(html, 'text/html');
  }

  async function applyFilter(url) {
    try {
      setLoading(true);
      const newDoc = await fetchFilteredSection(url);
      if (!newDoc) return;
      replaceContent('.productgrid--items', newDoc);
      replaceContent('.productgrid--sidebar', newDoc);
      replaceContent('.productgrid--filters', newDoc);
      replaceContent('.productgrid--masthead', newDoc);
      history.pushState({ filterUrl: url }, '', url);
      bindFilterLinks();
      bindSortSelect();
      bindClearLinks();
    } catch (error) {
      console.error('[AJAX Filter] Fehler:', error);
      window.location.href = url;
    } finally {
      setLoading(false);
    }
  }

  function bindFilterLinks() {
    document.querySelectorAll('.collection-filters__filter-link').forEach(function(link) {
      if (link.dataset.ajaxBound) return;
      link.dataset.ajaxBound = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const rawUrl = this.dataset.url;
        if (!rawUrl) return;
        applyFilter(decodeURIComponent(rawUrl));
      });
    });
  }

  function bindClearLinks() {
    ['.filter-item-clear-all', '.active-filter-group__item a'].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(link) {
        if (link.dataset.ajaxBound) return;
        link.dataset.ajaxBound = '1';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const href = this.getAttribute('href');
          if (href) applyFilter(href);
        });
      });
    });
  }

  function bindSortSelect() {
    const sortSelect = document.getElementById('product_grid_sort');
    if (!sortSelect || sortSelect.dataset.ajaxBound) return;
    sortSelect.dataset.ajaxBound = '1';
    sortSelect.addEventListener('change', function () {
      const currentUrl = new URL(window.location.href);
      if (this.value && this.value !== 'manual') {
        currentUrl.searchParams.set('sort_by', this.value);
      } else {
        currentUrl.searchParams.delete('sort_by');
      }
      applyFilter(currentUrl.pathname + currentUrl.search);
    });
  }

  function bindPopState() {
    window.addEventListener('popstate', function () {
      applyFilter(window.location.pathname + window.location.search);
    });
  }

  function init() {
    if (!document.querySelector('.productgrid--items')) return;
    bindFilterLinks();
    bindClearLinks();
    bindSortSelect();
    bindPopState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();